import React from 'react';

import { RADIO_BUTTON } from '../../utilities/constants';

import styles from '../../styles/componentStyle/radioButton/radioButton.scss';
import { RadioButtonIcon } from '../icons/RadioButtonIcon';

/**
 * ONかOFFを選択するラジオボタン用コンポーネント
 * @props {string}label:ラベル
 * @props {string}name:ステート内のプロパティ名
 * @props {string}onButtonLabel:ラジオボタンのON側のラベル
 * @props {string}offButtonLabel:ラジオボタンのOFF側のラベル
 * @props {string}rootClassName:親クラス名
 * @props {number}value:チェックデータ
 * @props {function}onChange:ラジオボタンを押した時の処理
 * @props {boolean}disabled:非活性
 */
export class OnOffRadioButton extends React.Component {
  constructor(props) {
    super(props);
    if (
      this.props.onChange !== 'undefined' &&
      typeof this.props.onChange === 'function'
    ) {
      this.onChange = this.props.onChange.bind(this);
    } else {
      console.warn('onChange is not function');
    }
  }

  // 画面表示
  render() {
    return (
      <div
        className={
          this.props.rootClassName
            ? `${this.props.rootClassName} ${styles.radioButton}`
            : styles.radioButton
        }
      >
        <div className='form__item'>
          <div className='form__label'>
            <span className='label'>{this.props.label}</span>
          </div>
          <div className='form__element'>
            {this.props.disabled ? (
              <div className='safari-linebreak'>
                <div>
                  {this.props.value === RADIO_BUTTON.On
                    ? this.props.onButtonLabel
                    : this.props.offButtonLabel}
                </div>
                <div>{this.props.messageDisable}</div>
              </div>
            ) : (
              <div className='form-list-radio'>
                <div className='form-list-radio__item'>
                  <label
                    htmlFor={`${this.props.name}` + '_on'}
                    className='radio'
                  >
                    <input
                      type='radio'
                      id={`${this.props.name}` + '_on'}
                      name={this.props.name}
                      checked={this.props.value === RADIO_BUTTON.On}
                      onChange={this.onChange}
                    />
                    <RadioButtonIcon className='icon--2x' />
                    <span>{this.props.onButtonLabel}</span>
                  </label>
                </div>
                <div className='form-list-radio__item'>
                  <label
                    htmlFor={`${this.props.name}` + '_off'}
                    className='radio'
                  >
                    <input
                      type='radio'
                      id={`${this.props.name}` + '_off'}
                      name={this.props.name}
                      checked={this.props.value === RADIO_BUTTON.Off}
                      onChange={this.onChange}
                    />
                    <RadioButtonIcon className='icon--2x' />
                    <span>{this.props.offButtonLabel}</span>
                  </label>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/radiobutton/OnOffRadioButton.jsx